import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_auth/enterprise/_with-org/_layout/plan'
)({
  component: () => <Navigate to="/subscriptions/plan" replace />,
});
